import React from 'react';
import { Row, Col } from 'antd';
import ContentCurveImage from './images/content2Curve.svg';

const ContentCurve = () => {
  return (
    <div>
      {/* Banner */}
      <Row
        align='middle'
        style={{
          padding: '67px 0 93px',
          backgroundColor: '#fefdfd',
          position: 'relative',
        }}
      >
        <Col
          xs={24}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            transform: 'translateY(-75%)',
          }}
        >
          <img src={ContentCurveImage} alt='interact app' width='100%' />
        </Col>
      </Row>
    </div>
  );
};

export default ContentCurve;
